const common = {
  namespaced: true,
  state: {
    loading: false,
  },
  mutations: {
    SET_LOADING: (state: any, loading: any) => {
      state.loading = true;
    },
    CLEAR_LOADING: (state: any) => {
      state.loading = false;
    },
  },
  actions: {},
};

export default common;
